<template>
  <div>
    <div class="formwapper">
      <form action="" class="fm">
      <span class="barspan">
        <div class="toolinner" v-if="isSubscribe === true">
          <Dropdown trigger="click">
            <a href="javascript:void(0)" class="searchtool">{{ year }}<Icon type="md-arrow-dropdown" /></a>
            <DropdownMenu slot="list">
              <div @click="setYear"><DropdownItem><span style="font-size: 0.6rem;">年份不限</span></DropdownItem></div>
                <div class="timerange">
                  <div class="tslctline">年份区间</div>
                  <div>
                      <div class="tslctline">
                        从：
                        <DatePicker :value="startDate" type="year" @on-change="starthandleChange" placeholder="开始年份" style="width: 100px;"></DatePicker>
                      </div>
                      <div class="tslctline">
                        至：
                        <DatePicker :value="endDate" type="year" @on-change="endhandleChange" placeholder="结束年份" style="width:100px"></DatePicker>
                      </div>
                  </div>
                </div>
            </DropdownMenu>
          </Dropdown>
          <!--          <Dropdown trigger="custom" >
                      <a class="searchtool" href="javascript:void(0)">
                        <span>{{ year }}</span>
                          <svg
                              t="1605669860338"
                              class="icon"
                              viewBox="0 0 1024 1024"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              p-id="3363"
                              width="14"
                              height="14"
                          >
                            <path
                                d="M787.52 398.528l-274.304 274.24-274.24-274.24z"
                                p-id="3364"
                                fill="#bfbfbf"
                            ></path>
                          </svg>
                      </a>
                      <DropdownMenu slot="list">
                          <DropdownItem @click="year = '年份不限'">年份不限</DropdownItem>
                          <div class="timerange">
                            <div class="tslctline">年份区间</div>
                            <div>
                                <div class="tslctline">
                                  从：
                                  <DatePicker :value="startDate" type="year" @on-change="starthandleChange" placeholder="开始年份" style="width: 100px;"></DatePicker>
                                </div>
                                <div class="tslctline">
                                  至：
                                  <DatePicker :value="endDate" type="year" @on-change="endhandleChange" placeholder="结束年份" style="width:100px"></DatePicker>
                                </div>
                            </div>
                          </div>
                      </DropdownMenu>
                    </Dropdown>-->
          <Dropdown trigger="click">
              <a class="searchtool" href="javascript:void(0)">{{ code }}<Icon type="md-arrow-dropdown" /></a>
              <DropdownMenu slot="list">
                <div @click="setCode"><DropdownItem>全部代码</DropdownItem></div>
                  <div class="timerange" style="width: 200px">
                    <div class="tslctline">搜索股票代码或简称</div>
                    <div class="aaaa">
                      <Select
                          v-model.trim="model"
                          multiple
                          filterable
                          transfer
                          :max-tag-count="0"
                          :max-tag-placeholder="maxTagPlaceholder"
                          @on-open-change="setSelectedCode"
                          style="width: 150px"
                      >
                        <Option v-for="item in stockList" :value="item.code" :key="item.code" style="width: 200px">{{ item.code+'---'+item.name }}</Option>
                    </Select>
                      <!--                      <Button type="success" style="margin-left: 12px;" @click="setSelectedCode">确定</Button>-->
                    </div>
                  </div>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="toolinner" v-if="isSubscribe === false">
           <a href="javascript:void(0)" class="searchtool" @click="trialMessage">{{ year }}<Icon type="md-arrow-dropdown" /></a>
           <a href="javascript:void(0)" class="searchtool" @click="trialMessage">{{ code }}<Icon type="md-arrow-dropdown" /></a>
        </div>
        <input @keyup.enter="searchByCondition" type="text" id="searchbar" class="searchInputValue"  autocomplete="off"/>
        <!--  此处input解决回车 刷新页面  -->
        <input type="text" style="display:none" />
      </span>
        <span class="searchspan">
        <input @click="searchByCondition" type="button" value="关键词分析" id="search" class="btn commonbtn" />
      </span>
      </form>
    </div>
    <div class="tab">
      <div class="tabinner">
        <a href="#" :class="{active: (this.changeDataBase==='nb')}" @click="setDatabase('nb')" class="tabitem" >
          <i class="iconfont icon-nianbao"></i>
          年报
        </a>
        <a href="#" :class="{active: (this.changeDataBase==='CMDA')}" @click="setDatabase('CMDA')" class="tabitem">
          <!--      <a href="#" :class="{active: (this.database==='CMDA')}" @click="trialMessage" class="tabitem dis">-->
          <i class="iconfont icon-taolun"></i>
          管理层讨论与分析
        </a>
        <a href="#" :class="{active: (this.changeDataBase==='Regulatory')}" @click="setDatabase('Regulatory')" class="tabitem">
          <!--      <a href="#" :class="{active: (this.database==='Regulatory')}" @click="trialMessage" class="tabitem dis">-->
          <i class="iconfont icon-wenxun"></i>
          监管问询
        </a>
        <a href="#" :class="{active: (this.changeDataBase==='PFBF')}" @click="setDatabase('PFBF')" class="tabitem">
          <!--      <a href="#" :class="{active: (this.database==='PFBF')}" @click="setDatabase('PFBF')" class="tabitem dis">-->
          <i class="iconfont icon-yeji"></i>
          业绩说明会
        </a>
        <a href="#" :class="{active: (this.changeDataBase==='Ipors')}" @click="setDatabase('Ipors')" class="tabitem">
          <!--      <a href="#" :class="{active: (this.database==='Ipors')}" @click="trialMessage" class="tabitem dis">-->
          <i class="iconfont icon-luyan"></i>
          IPO路演
        </a>
        <a href="#" :class="{active: (this.changeDataBase==='KADI')}" @click="setDatabase('KADI')" class="tabitem">
          <!--      <a href="#" :class="{active: (this.database==='KADI')}" @click="trialMessage" class="tabitem dis">-->
          <i class="iconfont icon-shenji"></i>
          关键审计事项
        </a>
        <a href="#" :class="{active: (this.changeDataBase==='invQA')}" @click="setDatabase('invQA')" class="tabitem">
          <!--      <a href="#" :class="{active: (this.database==='invQA')}" @click="trialMessage" class="tabitem dis">-->
          <i class="iconfont icon-wenda"></i>
          投资者问答
        </a>
        <!--      <a href="#" :class="{active: (this.changeDataBase==='AnalystReport')}" @click="setDatabase('AnalystReport')" class="tabitem">-->
        <!--        <i class="iconfont icon-fenxishi"></i>-->
        <!--        公司研究-->
        <!--      </a>-->
        <router-link :to="'/more/more'">
          <a href="#" class="tabitem">更多</a>
        </router-link>
      </div>
    </div>
    <div class="sampleData_table_div" style="width: 940px;margin: 0 auto;margin-top: 30px;">
      <div>
        <div class="demo-spin-col ivu-col" style="display: none;">
          <div class="ivu-spin ivu-spin-default ivu-spin-fix ivu-spin-show-text">
            <div class="ivu-spin-main"><span class="ivu-spin-dot"></span>
              <div class="ivu-spin-text"><i class="demo-spin-icon-load ivu-icon ivu-icon-ios-loading"
                                            style="font-size: 18px;"></i>
                <div>Loading</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div v-if="ListData.length > 0" class="scrollbars" style="overflow: auto;width: 940px;border: 1px solid rgba(223, 229, 240, 0.8);">
            <table cellspacing="0" cellpadding="0" class="simpledata_table table-bordered hoverline">
              <thead class="theadDivBox">
              <tr style="background-color: rgb(255, 255, 255);">
                <th>序号</th>
                <th style="text-align: left" v-for="(listDataItemsZero,listDataItemsZeroIndex) in ListData[0]" :key="listDataItemsZeroIndex">{{getTableHeader(listDataItemsZeroIndex)}}</th>
              </tr>
              </thead>
              <tbody class="tbodyDiv">
              <tr v-for="(listDataItems, listDataItemsIndex) in ListData" :key="listDataItemsIndex">
                <td>{{listDataItemsIndex+1}}</td>
                <td v-for="(subListDataItems, subListDataItemsIndex) in listDataItems" :key="subListDataItemsIndex">
                  <!--                <span>{{subListDataItems}}</span>-->
                  <span v-if="!(subListDataItems)"></span>
                  <span
                      v-if="(typeof (subListDataItems)!='string') || subListDataItems.constructor!=String"
                  >{{subListDataItems}}</span>
                  <span
                      v-else-if="(subListDataItems).length<30"
                  >{{subListDataItems}}</span>
                  <a
                      class="colDetail"
                      @click="hideOtherPopover"
                      href="javascript:void(0);"
                      data-toggle="popover"
                      data-placement="bottom"
                      :data-content="(subListDataItems)"
                      v-else
                  >点击查看</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div v-if="ListData.length === 0 && isSearch" style="text-align: center;font-size: 14px;padding-top: 100px;color: rgba(60, 90, 152, 0.5);height: 290px;border: 1px dashed rgba(223, 229, 240, 0.8);width: 940px;">
            <div style=""><i class="iconfont icon-kulian" style="font-size: 36px; color: rgba(60, 90, 152, 0.5);"></i>
              <p>当前查询条件下暂无数据</p>
            </div>
            <div class="demo-spin-col ivu-col" wfd-invisible="true" style="display: none;">
              <div class="ivu-spin ivu-spin-default ivu-spin-fix ivu-spin-show-text">
                <div class="ivu-spin-main"><span class="ivu-spin-dot" wfd-invisible="true"></span>
                  <div class="ivu-spin-text"><i class="demo-spin-icon-load ivu-icon ivu-icon-ios-loading"
                                                style="font-size: 18px;"></i>
                    <div>Loading</div>
                  </div>
                </div>
              </div>
            </div>
            <Spin size="large" fix v-if="ListDataLoading"></Spin>
          </div>
          <div v-if="ListData.length>0" style="margin-top: 10px;">
            <div class="ivu-alert ivu-alert-success" style="height: 34px;">
                        <span class="ivu-alert-message">
                          <i class="iconfont icon-yangben" style="font-size: 16px; margin-left: -6px; margin-right: 6px; color: rgb(25, 190, 107);"></i> 已为您显示所设置条件下前
                          <span style="color: rgb(25, 190, 107);">20</span> 条预览数据，更多数据请
                          <span class="simpledataDownload" @click="DownLoadM">
                            <i class="iconfont icon-xiazai1" style="font-size: 14px;margin-right: -4px;"></i>
                            下载 </span>后查看
                        </span>
              <span class="ivu-alert-desc"></span>
            </div>
            <Spin size="large" fix v-if="ListDataLoading"></Spin>
          </div>
          <div class="table-footer" style="display: none">
            <Button
                id="bownloadbtn"
                @click="DownLoadM"
                icon="md-download"
                shape="circle"
            ></Button>
          </div>
        </div>
      </div>
    </div>
    <!--提示对话框-->
    <div class="modal fade" id="errorInfoModal" tabindex="-1" role="dialog" aria-labelledby="errorInfoModal"
         aria-hidden="true">
      <div class="modal-dialog" style="width: 430px;background:transparent;">
        <div class="modal-content" style="border:0;">
          <!--          <div class="modal-header" style="border-bottom: none">-->
          <!--            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" >-->
          <!--              &times;-->
          <!--            </button>-->
          <!--            <h4 class="modal-title">-->
          <!--              <span style="color:white;font-size:16px;">提示</span>-->
          <!--            </h4>-->
          <!--          </div>-->
          <div class="modal-body" style="background:white;border-radius: 6px;padding: 42px 20px 10px;">
            <div style="height:60px;padding:2px 0px;">
              <i class="iconfont icon-alert" style="font-size: 30px;vertical-align: middle;color:#4184f3"/>
              <span style="margin-left: 10px;font-size: 14px;display: inline-block;position: absolute;width: 350px;">{{
                  errorInfoArray
                }}</span>
            </div>
          </div>
          <div class="modal-footer"
               style="padding: 20px 15px 15px 0;background:white;border-top: none;border-radius: 6px;">
            <button type="button" @click="() => {this.dataload = false}" class="commonbtn" data-dismiss="modal" style="width: 75px;height: 32px;outline:none;margin-right:10px ">知道了</button>
<!--            <button type="button" @click="showPersonCenter" class="commonbtn" data-dismiss="modal"style="width: 100px;height: 32px;outline:none">打开个人中心</button>-->
            <button type="button" @click="showPersonCenter" class="commonbtn" data-dismiss="modal"style="width: 100px;height: 32px;outline:none">下载客户端</button>
          </div>
        </div>
      </div>
    </div>
    <!--用户权限对话框-->
    <div class="modal fade" id="roleInfoModal" tabindex="-1" role="dialog" aria-labelledby="roleInfoModal"
         aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog" style="width: 430px;background:transparent;">

        <div class="modal-content" style="border:0px;">
          <!--          <div class="modal-header">-->
          <!--            <button type="button" data-dismiss="modal" aria-hidden="true" class="close" style="font-size: 26px; outline: none; color: black;">-->
          <!--              ×-->
          <!--            </button>-->
          <!--            <h4 class="modal-title"><span style="color: black; font-size: 16px;">提示</span></h4>-->
          <!--          </div>-->
          <div class="modal-header" style="border-bottom: none;padding-bottom: 5px">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
              &times;
            </button>
            <h4 class="modal-title">
              <span style="color:white;font-size:16px;">提示</span>
            </h4>
          </div>
          <div class="modal-body" style="background:white;border-radius: 6px;padding: 0px 20px 39px;">
            <div style="height:40px;padding:2px 0px;">
              <i class="iconfont icon-quanxian" style="font-size: 30px;vertical-align: middle;color:#4184f3"/>
              <span v-show="AuthLevel===1" style="margin-left:10px;font-size:14px;">您目前的登录状态下只能下载本库的 <span
                  style="color: #e52e5e">样本数据</span></span>
              <span v-show="AuthLevel===2" style="margin-left:10px;font-size:14px;">您目前的登录状态下只能下载本库的 <span
                  style="color: #e52e5e">高级试用数据</span></span>
              <p style="margin-left: 56px">如需下载正式数据，请<a href="#contact" data-toggle="modal" data-target=".contactUs">联系我们</a>或使用正式账号
                <a class="rolelogin" @click="gotoLogin">登录</a></p>
            </div>
          </div>
          <div class="modal-footer"
               v-show="showAuthModel"
               style="padding: 20px 15px 15px 0px;;background:white;border-top: none;border-radius: 6px;">
            <div style="float: left; margin-left: 12px;">
              <input id="noWarningCheck" type="checkbox"
                     style="position: relative; top: 2px; width: 14px; height: 14px; outline: none;">
              <label for="noWarningCheck"
                     style="font-weight: 500; cursor: pointer;font-size: 12px">&nbsp;本次登录不再提醒</label></div>
            <button type="button" class="commonbtn" data-dismiss="modal"
                    @click="asd"
                    style="width: 75px;height: 32px;outline:none;">继续下载
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--下载概要模态框-->
    <div class="modal fade" id="downloadSummaryModal" tabindex="-1" role="dialog" aria-labelledby="downloadSummaryModal"
         aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog" style="width: 1000px;background:transparent;">
        <div class="modal-content" style="border:0px;">
          <div class="modal-header" style="padding: 7px 15px;;border-radius: 4px 4px 0 0">
            <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                    style="font-size:26px;outline:none;color:#4773bb;font-weight: 500;opacity: .3;">
              &times;
            </button>
            <h4 class="modal-title">
              <i class="iconfont icon-gaiyao"
                 style="color: #4773bb;font-size: 24px !important;vertical-align: middle;margin-right: 3px;"></i>
              <span style="color:#4773bb;font-size:16px;">下载概要</span>
            </h4>
          </div>
          <div class="modal-body" style="background:white;overflow:auto;">
            <div class="downloadSummary_div">
              <div class="downloadSummary_table_div">
                <!--                test-->
                <table style="width: 100%;">
                  <tbody>
                  <tr style="border-bottom: 1px solid rgba(223, 229, 240, 0.8);">
                    <th class="title_td" colspan="1">下载表名：</th>
                    <td class="value_td" colspan="1">词频</td>
                    <th class="title_td" colspan="1">时间范围：</th>
                    <td class="value_td" colspan="1">{{ this.year }}</td>
                    <th class="title_td" colspan="1">股票代码：</th>
                    <td class="value_td" colspan="1">
                      {{ this.code === "股票代码" ? "暂未选择 " : this.code }}
                    </td>
                    <th class="title_td" colspan="1">输出类型：</th>
                    <td class="value_td" colspan="1">{{ "Xlsx" | fileTypeFilter }}</td>
                  </tr>
                  <tr style="border-bottom: 1px solid rgba(223, 229, 240, 0.8);">
                    <th class="title_td" colspan="1">代码设置：</th>
                    <td class="value_td" colspan="5">默认</td>
                  </tr>
                  <tr style="border-bottom: 1px solid rgba(223, 229, 240, 0.8);">
                    <th class="title_td" colspan="1">字段选择：</th>
                    <td class="value_td" colspan="5">
                      全部
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div class="download_bottomInfo_div">
                  <div style="float:left;line-height:34px;">
                      <input type="checkbox" id="sendEmail_checkbox" style="width:15px;height:15px;position:relative;top:3px;" v-model='sendEmail_checkbox'>
                      <label for="sendEmail_checkbox" style="cursor:pointer;font-weight:500;">发送下载链接到邮箱</label>
                  </div>
                  <div style="float:left;margin-left:20px;">
                      <input v-model="email" disabled type="text" class="form-control email_input" placeholder="请输入邮箱地址" style="width:300px;">
                  </div>
                  <div class="sendEmailSuccess_div" style="float:left;margin-left:20px;line-height:34px;display:none;">
                      <i style="color:#5EB346;" class="icon icon-check-circle"></i>
                      <span style="color:#5EB346;">已发送下载链接至邮箱</span>
                  </div>
              </div> -->
            </div>
          </div>
          <div class="modal-footer" style="padding: 2px 18px;background:white;border-radius: 4px">
            <div class="addToDownList">
              <button class="download_button commonbtnol" @click="AddDownloadTask">
                <Icon type="md-download"/>
                添加到下载队列
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 下载模态框 -->
    <div class="modal fade" id="dataDownloadModal" tabindex="-1" role="dialog" aria-labelledby="dataDownloadModal"
         aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog" style="width: 1000px;background:transparent;">
        <div class="modal-content" style="border:0px;">
          <div class="modal-header" style="padding: 7px 15px;background:#fff;border-radius: 4px 4px 0 0;">
            <button type="button" @click="closePreviewDialog" class="close" data-dismiss="modal" aria-hidden="true"
                    style="font-size:26px;outline:none;color:rgb(71, 115, 187);">
              &times;
            </button>
            <h4 class="modal-title">
              <i class="iconfont icon-xiazai" STYLE="color: #4184f3;font-size: 20px;vertical-align: middle;"></i>
              <span style="font-size:16px;color: rgb(71, 115, 187)"> 下载进度</span>
            </h4>
          </div>
          <div class="modal-body aaaa" style="background:white;padding: 60px 75px 75px 60px;">
            <Steps :current="downloadCurrentStep" class="ivustep">
              <Step title="已提交" content="下载任务已提交">
              </Step>
              <Step title="查询中">
                <div slot="icon" v-if="downloadPercentage <= 1" style="width: 24px">
                  <Spin fix>
                    <div class="loader">
                      <svg class="circular" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" r="20" fill="none" :stroke-width=5
                                stroke-miterlimit="10"></circle>
                      </svg>
                    </div>
                  </Spin>
                </div>
                <div slot="content">
                  <span v-show="downloadPercentage <= 1">正在查询，请稍候...</span>
                  <span v-show="downloadPercentage > 1">数据查询完成</span>
                </div>
              </Step>
              <Step title="转换中">
                <div slot="title">
                  <span>转换中</span>
                </div>
                <div slot="content">
                  <span v-if="downloadPercentage !== 100">文件正在转换
                    <span>{{ downloadPercentage }}%</span>
                  </span>
                  <span v-else>文件转换完成</span>
                  <div id="cir2" v-if="downloadPercentage < 100">
                    <i-circle :percent="downloadPercentage" :stroke-color="color" :size="40" :stroke-width=3></i-circle>
                  </div>
                </div>
              </Step>
              <Step title="完成" content="可点击下载"></Step>
            </Steps>
          </div>
          <div class="modal-footer" style="padding: 15px 15px;background:white;border-radius: 0 0 4px 4px;">
            <Alert show-icon style="height: 34px;display: inline-block;float: left;margin: 0px;">
              <Icon type="md-bulb" slot="icon"></Icon>
              登录状态下，下载进度将被保留在下载列表中
            </Alert>
            <Button @click="goToHistory" style="margin-right: 10px;width: auto">前往下载列表中查看</Button>
            <Button
                :disabled="downloadCurrentStep!=3"
                @click="okDownload"
                type="primary"
                :loading="downloadCurrentStep!=3"
                style="width: 72px;height: 32px;line-height: 32px"
            >
              下载
            </Button>
          </div>
        </div>
      </div>
    </div>
    <!-- <Modal v-model="modal1" title="下载详情" @on-ok="ok" @on-cancel="cancel">
      <Form :model="formItem" :label-width="80">
        <FormItem label="数据类型">
          <Input v-model="formItem.leixing" disabled></Input> -->
    <!-- <RadioGroup v-model="formItem.leixing">
      <Radio label="基本信息" disabled>
        <Icon type="logo-apple"></Icon>
        <span>基本信息</span>
      </Radio>
      <Radio label="词频" disabled>
        <Icon type="logo-android"></Icon>
        <span>词频</span>
      </Radio>
      <Radio label="情感" disabled>
        <Icon type="logo-windows"></Icon>
        <span>情感</span>
      </Radio>
    </RadioGroup>
  </FormItem>
  <FormItem label="年份">
    <Input v-model="formItem.years" disabled></Input>
  </FormItem>
  <FormItem label="股票代码">
    <Input
      v-model="formItem.textarea"
      type="textarea"
      :autosize="{minRows: 6,maxRows: 12}"
      disabled
    ></Input>
  </FormItem>
</Form>
</Modal> -->
  </div>
</template>

<script>
import axios from "@/api/axios";
import {mapGetters, mapState, mapMutations} from "vuex";
import Bus from "../../bus";
export default {
  name: "searchInput",
  props:["database","searchKeyWord"],
  data(){
    return{
      timer:null,
      ListDataLoading: false,
      changeDataBase: 'nb',
      AuthLevel: 1,
      stockList: [],
      //选择后的股票代码
      model: [],
      year:'年份不限',
      code:'股票代码',
      //开始年份
      startDate: '',
      //结束年份
      endDate: '',
      //搜索关键字
      keyword: '',
      errorInfoArray: "",
      ListData:[],
      formItem: {
        leixing: "词频",
        years: "",
        radio: "male",
        checkbox: [],
        switch: true,
        date: "",
        time: "",
        slider: [20, 50],
        textarea: ""
      },
      isSearch: false,
      auths: '',
      isSubscribe: false,
      showAuth: true,
      downloadCurrentStep: 1,
      downloadTasks: [],
      modalDownload: false,
      fileName: '',
      downloadPercentage: 0,
      zipPercentage: 0,
    }
  },
  created() {
    this.auths = this.$store.state.userInfo.auths
    this.keyword = this.searchKeyWord
    this.getStockList()
  },
  mounted() {
    this.isSubscription(this.changeDataBase)
  },
  filters: {
    fileTypeFilter: value => {
      return [
        {key: "Xlsx", value: "Excel2007格式（*.xlsx）"},
        {key: "Txt", value: "TXT文本格式（*.txt）"},
        {key: "Txt_mat", value: "Txt创建Matlab数据集 (*.mat)"},
        {key: "Txt_dta", value: "Txt创建Stata数据集 (*.dta)"},
        {key: "Txt_r", value: "Txt创建R数据集 (*.R) "},
        {key: "Csv", value: "逗号分隔文本 (*.csv) "},
        {key: "Csv_mat", value: "Csv创建Matlab数据集 (*.mat)"},
        {key: "Csv_dta", value: "Csv创建Stata数据集 (*.dta)"},
        {key: "Xml", value: "Xml文件 (*.xml)"},
        {key: "Xls", value: "Excel2003格式（*.xls）"},
        {key: "Xls_mat", value: "Excel格式创建Matlab数据（*.xls）"},
        {key: "Html", value: "HTML格式（*.html）"},
        {key: "Sav", value: "SPSS格式（*.sav）"},
        {key: "Dbf", value: "DBase dbf格式（*.dbf）"}
      ].filter(s => s.key == value)[0].value;
    }
  },
  computed: {
    ...mapState(["SystemList"]),
    ...mapGetters(['getAuths']),
    showAuthModel() {
      if (this.showAuth === false) {
        return false;
      }
      if ($.cookie("remindAuth") === "false") {
        return false
      } else {
        return true
      }
    },
    code(){
      if(this.model.length>0){
        return this.model.join(",")
      }else{
        return ""
      }
    },
    year(){
      return (!this.startDate && !this.endDate) ? "年份不限" : this.startDate + "-" + this.endDate
    }
    
  },
  watch: {
    database(newVal, oldVal) {
      this.changeDataBase = newVal
      this.isSubscription(this.changeDataBase)
    },
    startDate(newVal, oldVal) {
      if (newVal === '') {
        if (this.endDate === '') {
          this.year = '年份不限'
        }
      }
      if (this.endDate) {
        if (newVal > this.endDate) {
          this.$Message.info("开始日期不能大于结束日期!");
          this.year = '年份不限';
          this.endDate = ''
          this.startDate = ''
        }
      }

    },
    endDate(newVal, oldVal) {
      if (newVal === '') {
        if (this.startDate === '') {
          this.year = '年份不限'
          this.endDate = ''
          this.startDate = ''
        }
      }
      if (this.startDate) {
        if (newVal < this.startDate) {
          this.$Message.info("结束日期不能小于开始日期!");
          this.year = '年份不限';
        }
      }
    },
    changeDatabase(newVal, oldVal) {
      this.isSubscription(newVal);
    }
  },
  updated(){
    $('[data-toggle="popover"]').popover({
      template:
          '<div class="popover" style="font-family:微软雅黑;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content" style="max-height:200px;overflow:auto;"></div></div>'
    });
    $("#dataPreviewModal .modal-content").click(e => {
      if (!$(e.target).hasClass("colDetail")) {
        $(".colDetail").popover("hide");
      }
    });
  },
  methods:{
    ...mapMutations(["PUSH_TASKMD5lIST","SET_ISDOWNLOAD"]),
    GetAuthLevelBySys(sys){
      const auths = this.getAuths
      this.stockCode_nameArray = []
      for (let key in auths) {
        if (auths.hasOwnProperty(key)) {
          const item = auths[key];
          if (item.database === sys) {
            //未过期才授权
            const nowDate = new Date().getTime();
            const authDate = new Date(item.endDate).getTime()
            if (authDate > nowDate) {
              this.AuthLevel = item.level
            }
          }
        }
      }
    },
    //退出登录并跳转至登录界面
    gotoLogin: async function () {
      $("#roleInfoModal").modal('hide');
      await this.signOut();
      this.SET_USER_SIGNOUT();
      this.$store.state.taskMD5List = []
      window.sessionStorage.removeItem("store")
      this.$router.push('/');
      $.cookie("modalFlag", "", {expires: -1});
    },
    closePreviewDialog() {
      clearInterval(this.timer);
      // $(".sampleData_table_div").scrollTop(0);
    },
    okDownload() {
      let md5 = this.downloadTasks.taskMD5;
      //修改下载状态为已经下载
      this.SET_ISDOWNLOAD(md5);
      axios
          .post("/api/getDownloadUrl", {md5: md5})
          .then(response => {
            var a = document.createElement("a");
            a.href = response.data.data
            a.click()
            $("#dataDownloadModal").modal("hide");
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    cancel() {
      clearInterval(this.timer);
      // this.modalDownload = false;
      $("#dataDownloadModal").modal("hide");
    },
    goToHistory() {
      clearInterval(this.timer);
      $("#dataDownloadModal").modal("hide");
      this.$emit('showHistory')
    },
    showPersonCenter() {
      // Bus.$emit("showSupplyDown")
      window.open("https://xueguo.oss-cn-shanghai.aliyuncs.com/aitextclient/%E7%88%B1%E6%96%87%E6%9C%AC%E5%AE%A2%E6%88%B7%E7%AB%AF1.0.65Setup.exe");
      this.modalDownload = false;
      },
    isSubscription(val) {
      this.isSubscribe = this.auths.find(item => item.database === val).level === 3;
    },
    setSelectedCode() {
      if (this.model.length > 0) {
        this.code = '';
        this.code = "已选" + this.model.length
      }
    },
    setYear() {
      this.year = '年份不限'
      this.startDate = ''
      this.endDate = ''
    },
    setCode() {
      this.code = '全部代码'
      this.model = []
    },
    getStockList() {
      const codeUrl = "/stockIdTable.json"
      axios.get(codeUrl).then(res=>{
        let dataArray = res.data;
        for (let i = 0; i < dataArray.length; i++) {
          const oneDataObj = dataArray[i];
          this.stockList.push(oneDataObj);
        }
      }).catch(err =>{
        console.warn(err);
      })
    },
    getTableHeader(val) {
      if (val === 'Year') return '会计年度'
      if (val === 'Stockcode') return '证券代码'
      if (val === 'Keyword') return '关键字'
      if (val === 'Exactword') return '精确词频'
      if (val === 'Extendword') return '扩展词频'
      if (val === 'Stockname') return '证券简称'
      if (val === 'Enddate') return '统计日期'
      if (val === 'Texttype') return '文本类型'
      if (val === 'Qnumber') return '问题序号'
      if (val === 'Dnumber') return '文本编号'
      if (val === 'Ltrcat') return '函件类别'
      if (val === 'Inqtitl') return '问询标题'
      if (val === 'RplyDdln') return '限期回复日期'
      if (val === 'Corplydt') return '公司回复日期'
      if (val === 'Texttype') return '文本类型'
      if (val === 'Exactword_Rply') return '问询精确词频'
      if (val === 'Exactword_Inq') return '问询扩展词频'
      if (val === 'Extendword_Rply') return '回复精确词频'
      if (val === 'Extendword_Inq') return '回复扩展词频'
      if (val === 'Kamatstype') return '事项类型'
      if (val === 'Kamatcontent') return '事项内容'
      if (val === 'Solutions') return '应对方法'
      if (val === 'Exactword_content') return '内容精确词频'
      if (val === 'Extendword_content') return '回复精确词频'
      if (val === 'Exactword_Solutions') return '应对精确词频'
      if (val === 'Extendword_Solutions') return '应对精确词频'
      if (val === 'Date') return '统计日期'
      if (val === 'Dnumbr') return '文本序号'
      if (val === 'Anncdate') return '公告日期'
      if (val === 'Andate') return '统计日期'
      if (val === 'Qnumbr') return '问题序号'
      if (val === 'B_name') return '券商名称'

    },
    maxTagPlaceholder (num) {
      return '已选 '+ num;
    },
    starthandleChange (date) {
      this.startDate = date;
      this.year = this.startDate + ' - ' + this.endDate;
    },
    endhandleChange (date) {
      this.endDate = date;
      this.year = this.startDate + ' - ' + this.endDate;
    },
    //发起搜索请求
    searchByCondition(){
      this.keyWordQuery()
    },
    trialMessage(){
      this.$Message.info("您尚未采购数据库 "+this.SystemList[this.changeDataBase].name+" 无法进行筛选，请选中您已经采购的数据库进行筛选")
    },
    //权限验证
    asd() {
      if ($("#noWarningCheck")[0].checked) {
        $.cookie('remindAuth', 'false');
        this.showAuth = false
      }
      $("#downloadSummaryModal").modal();
    },
    getDownloadResult(md5) {
      this.downloadCurrentStep = 1;
      this.timer = setInterval(() => {
        axios
            .post("/api/getDownloadResult", {md5})
            .then(response => {
              if (response.data.data.percentage > 0) {
                this.downloadCurrentStep = 2
              }
              if (response.data.data.process === 'finish') {
                this.downloadPercentage = 100;
                this.fileName = response.data.data.condition
                clearInterval(this.timer);
                this.downloadCurrentStep = 3;
              }
              this.downloadPercentage = Number.parseInt(response.data.data.percentage)
              this.downloadTasks = response.data.data
            })
            .catch(function (error) {
              console.log(error);
            });
      }, 3000);
    },
    AddDownloadTask() {
      $("#downloadSummaryModal").modal("hide");
      let data = this.getParams();
      if (data) {
        this.downloadCurrentStep = 1
        this.downloadTasks = []
        this.zipPercentage = 0;
        this.downloadPercentage = 0;
        axios
            .post("/api/ExportFile", data)
            .then(response => {
              if (response.data.msg === '403') {
                this.$Message.error("没有下载权限!")
              } else {
                if (response.data.status) {
                  //添加进下载记录
                  let flag = false
                  for (let i = 0; i < this.$store.state.taskMD5List.length; i++) {
                    if (this.$store.state.taskMD5List[i].md5 === response.data.data) {
                      flag = true
                    }
                  }
                  if (!flag) {
                    this.PUSH_TASKMD5lIST(response.data.data)
                  }
                  $("#dataDownloadModal").modal();
                  this.getDownloadResult(response.data.data);
                } else {
                  this.$Notice.error({
                    title: "提示",
                    desc: response.data.msg
                  });
                }
              }
            })
            .catch(function (error) {
              console.log(error);
            });
      }
    },
    getParams: function(){
      let data = {};
      data["mokuai"] = this.changeDataBase
      data["dataType"] = "NoLimit"
      data["type"] = "cipin"
      data["keyword"] = [this.keyword]
      // 判断开始日期和结束日期不为空 和单项为空
      if (this.startDate && this.endDate) {
        data["dataType"] = "ByYear";
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        let years = [];
        for(var i=0; i<=parseInt(this.endDate)-parseInt(this.startDate);i++){
          years.push(parseInt(this.startDate)+i)
        }
        data["year"] = years;
      } else if (!this.startDate && this.endDate) {
        this.$Message.info("请输入开始日期!")
        return
      } else if (!this.endDate && this.startDate) {
        this.$Message.info("请输入结束日期!")
        return
      }
      data["code"] = this.model;
      return data
    },
    DownLoadM: function() {
      // let module = this.$store.state.SystemList[this.changeDataBase].module;
      // // 年份
      // let year = (!this.startDate && !this.endDate) ? "年份不限" : this.startDate + "-" + this.endDate
      // // 股票代码
      // let code = this.code ? this.code : false
      // this.$router.push("/views/" + module + "/" + this.changeDataBase + "/cipin?keyword=" + this.keyword + "&year=" + year + "&code=" + code)
      // this.$store.commit("setIsDownLoadM", true);

      
      this.$store.commit("setIsDownLoadM", false);

      this.GetAuthLevelBySys(this.changeDataBase);
      var params = this.getParams()
      if (params) {
        if (this.AuthLevel === 3) {
          $("#downloadSummaryModal").modal();
        } else {
          if (this.showAuthModel) {
            $("#roleInfoModal").modal();
          } else {
            $("#downloadSummaryModal").modal();
          }
        }
      }


      //判断是否是词频数据库，词频数据库未购买不提供样本下载
      // const url = this.$route.path.split('/')
      // if(url[url.length - 1]==='cipin') {
      //   if(this.AuthLevel!==3&&this.AuthLevel!==2) {
      //     this.$Message.info('您目前处于试用阶段，词频数据不提供下载哟')
      //     return
      //   }
      // }
      // var params = this.getParams()
      // if(params){
      //   if(this.AuthLevel===3) {
      //     $("#downloadSummaryModal").modal();
      //   }else {
      //     if(this.showAuthModel) {
      //       $("#roleInfoModal").modal();
      //     }else {
      //       $("#downloadSummaryModal").modal();
      //     }
      //   }
      // }

      /**********************/
      // if (this.selectedYears.length == 0) {
      //   this.formItem.years = "时间不限";
      // } else {
      //   this.formItem.years = this.selectedYears;
      // }
      // if (this.targetKeys2.length == 0) {
      //   this.formItem.textarea = "全部代码";
      // } else {
      //   this.formItem.textarea = this.targetKeys2;
      // }
      // // alert(hex_md5("input string"));
      // this.modal1 = true;
    },
    async keyWordQuery() {
      axios.defaults.timeout = 15000;
      this.keyword = document.getElementsByClassName('searchInputValue')[0].value;
      // 判断关键字是否输入
      if (!this.keyword) {
        this.$Message.info("请输入关键词!")
        return
      }
      if (this.keyword.length > 5) {
        this.$Message.info("关键词字数不能大于5!")
        return
      }
      let data = {};
      data["mokuai"] = this.changeDataBase
      data["dataType"] = "NoLimit"
      data["type"] = "cipin"
      data["keyword"] = [this.keyword]
      // 判断开始日期和结束日期不为空 和单项为空
      if (this.startDate && this.endDate) {
        data["dataType"] = "ByYear";
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        let years = [];
        for(var i=0; i<=parseInt(this.endDate)-parseInt(this.startDate);i++){
          years.push(parseInt(this.startDate)+i)
        }
        data["year"] = years;
      } else if (!this.startDate && this.endDate) {
        this.$Message.info("请输入开始日期!")
        return
      } else if (!this.endDate && this.startDate) {
        this.$Message.info("请输入结束日期!")
        return
      }
      data["code"] = this.model;
      this.ListDataLoading = true
      await axios.post("/api/preview", data)
          .then((res) => {
            if (res.status) {
              this.ListData = res.data.data
              this.isSearch = true;
            } else {
              this.$Message.error(res.msg)
            }
            this.ListDataLoading = false
          }).catch(error => {
        this.ListData = []
        console.warn(error)
        this.ListDataLoading = false
      });
      if (this.ListData.length > 0) {
        await axios.post("/api/containKey", data)
            .then(res => {
              if (res.data.data !== "关键字都存在") {
                this.errorInfoArray = "多个词汇中，存在有未收录词，请单独搜索：" + res.data.data;
                $("#errorInfoModal").modal();
              }
            });
      } else {
        await axios.post("/api/userKeyCon", data)
            .then(res => {
              this.errorInfoArray = "该关键词未收录在网页版中，您可以在增强版客户端中通过自定义文本和关键词的方式进行分析。";
              $("#errorInfoModal").modal();
              return;
              // 已经查询过该数据，直接进入个人中心查看即可
              if (res.data.data.exist === "已经存在") {
                this.errorInfoArray = "该关键词已搜索，请到个人中心查询。若不能下载，请等待一个工作日。";
                $("#errorInfoModal").modal();
                return;
              }
              // 1.正式用户
              if (res.data.data.state === "正式用户") {
                axios.post("/api/keyDefine", data).then(res => {
                  if (res.data.msg === "数据库不存在") {
                    this.errorInfoArray = "尊敬的用户：\n" +
                        // "您好！该关键词属于新词，无法即时展示，目前已经进入后台搜索，请到个人中心查询，您将在一个工作日内获得搜索结果。为了快速获得搜索结果，您也可以在搜索时设置时间或股票代码。。";
                        // "您好！该关键词属于新词，无法即时展示，您可以在客户端中,通过自定义文本和关键词的方式进行分析";
                        "该关键词未收录在网页版中，您可以在增强版客户端中通过自定义文本和关键词的方式进行分析。";
                    $("#errorInfoModal").modal();
                  } else if (res.data.msg === "数据库已存在") {
                    this.errorInfoArray = "该关键字已被搜索，请查看个人中心";
                    $("#errorInfoModal").modal();
                  } else {
                    this.errorInfoArray = "关键词提交失败请重试，如果多次失败请联系客服";
                    $("#errorInfoModal").modal();
                  }
                }).catch(() => {
                  this.errorInfoArray = "关键词提交失败请重试，如果多次失败请联系客服";
                  $("#errorInfoModal").modal();
                });
              } else {
                // 判断剩余词语的数量不可以查询
                if (res.data.data.limited >= res.data.data.limit) {
                  this.errorInfoArray = "个人试用账号特殊关键词查询已达上限（个人试用仅支持查询五个关键词）";
                  $("#errorInfoModal").modal();
                }else { //判断可以查询
                  // 查询的词语数量不能超过限定
                  let count = this.keyword.split(",");
                  if (count.length + res.data.data.limited > res.data.data.limit) {
                    let aaa = res.data.data.limit - res.data.data.limited
                    this.errorInfoArray = "关键词查询超过上限，您能查询关键词数量为" + aaa + "个";
                    $("#errorInfoModal").modal();
                  } else {
                    axios.post("/api/keyDefine", data).then(res => {
                      if (res.data.msg === "数据库不存在") {
                        this.errorInfoArray = "尊敬的用户：\n" +
                            // "您好！该关键词属于新词，无法即时展示，目前已经进入后台搜索，请到个人中心查询，您将在一个工作日内获得搜索结果。为了快速获得搜索结果，您也可以在搜索时设置时间或股票代码。。";
                            "该关键词未收录在网页版中，您可以在增强版客户端中通过自定义文本和关键词的方式进行分析。";
                        $("#errorInfoModal").modal();
                      } else if (res.data.msg === "数据库已存在") {
                        this.errorInfoArray = "该关键字已被搜索，请查看个人中心";
                        $("#errorInfoModal").modal();
                      } else {
                        this.errorInfoArray = "关键词提交失败请重试，如果多次失败请联系客服";
                        $("#errorInfoModal").modal();
                      }
                    }).catch(() => {
                      this.errorInfoArray = "关键词提交失败请重试，如果多次失败请联系客服";
                      $("#errorInfoModal").modal();
                    });
                  }
                }
              }
            })
      }
    },
    setDatabase(value){
      this.changeDataBase = value
      this.isSubscription(this.changeDataBase)
    },
    hideOtherPopover(e) {
      $(e.currentTarget).addClass("thisPopover");
      var updateObjArray = $(".colDetail");
      for (var i = 0; i < updateObjArray.length; i++) {
        var oneObj = $(updateObjArray[i]);
        if (!oneObj.hasClass("thisPopover")) {
          if (
              oneObj
                  .parent()
                  .find("div:first-child")
                  .hasClass("arrow")
          ) {
            oneObj.click();
          }
        }
      }
      $(e.currentTarget).removeClass("thisPopover");
    },
  }
}
</script>

<style scoped lang="scss">
#_type {
  width: 100%;
  min-height: 920px;
  margin: 0;
  padding: 0;
  overflow: auto;
}
/*通用按钮类*/
.commonbtn{
  background-color: #4184f3;
  color: white;
  border: 1px solid #4184f3;
  border-radius: 4px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}
.commonbtn:hover{
  background-color: #5e9bff;
  border: 1px solid #5e9bff;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}
.commonbtn:focus{
  outline: none;
}
/*通用按钮类*/
.commonbtnol{
  background-color: white;
  color: #4773bb;
  border: 1px solid rgba(223, 229, 240, 0.8);
  border-radius: 4px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
}
.commonbtnol:hover{
  background-color: #4184f3;
  border: 1px solid #4184f3;
  color: white;
  transition: ease all 0.2s;
  -webkit-transition: ease all 0.2s;
  -moz-transition: ease all 0.2s;
  -ms-transition: ease all 0.2s;
}
.commonbtnol:focus{
  outline: none;
}
#bownloadbtn{
  width:40px;
  height:40px;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s;
  -moz-transition: ease all 0.4s;
  -ms-transition: ease all 0.4s;
  background:white;
  color:#4184f3;
  border: 1px solid rgba(223, 229, 240, 0.8);
  font-size:18px;
  font-weight:700;
}
#bownloadbtn:hover{
  background:#4184f3;
  color:white;
  border: 1px solid #4184f3;
  width:90px;
  border-radius: 30px;
  transition: ease all 0.3s;
  -webkit-transition: ease all 0.3s;
  -moz-transition: ease all 0.3s;
  -ms-transition: ease all 0.3s;
}
#bownloadbtn:hover::after{
  content:'下载';
  font-size:14px;
  position:relative;
  top:-2px;
  animation:myfirst 0.4s;
  -webkit-animation:myfirst 0.4s; /* Safari and Chrome */
  -moz-animation:myfirst 0.4s; /* Firefox */
  -o-animation:myfirst 0.4s; /* Opera */
}
#bownloadbtn:focus{
  width:90px;
  border-radius: 30px;
  background:#4184f3;
  color:white;
  border: 1px solid #4184f3;
}
#bownloadbtn:focus::after{
  content:'下载';
  font-size:14px;
  position:relative;
  top:-2px;
}

// form
.formwapper {
  margin: 0 auto;
  width: 690px;
}
.fm {
  width: 692px;
  margin: 0 auto;
  display: inline-block;
}

// search
.barspan {
  position: relative;
  width: 546px;
}
#searchbar {
  width: 352px;
  height: 36px;
  padding: 2px 16px;
  font-size: 16px;
  margin: 0;
  vertical-align: top;
  outline: 0;
  box-shadow: none;
  border-radius: 10px 0 0 10px;
  border: 2px solid #c4c7ce;
  background: #fff;
  color: #222;
  overflow: hidden;
  box-sizing: content-box;
  padding-left: 200px;
}
#searchbar:hover {
  border-color: #a7aab5;
}
#searchbar:focus {
  border-color: #4184f3;
  background-color: inherit;
  opacity: 1;
}
.toolinner {
  position: relative;
  top: 32px;
  z-index: 1;
  left: 20px;
  width: 194px;
}
.searchtool {
  color: #666;
  margin-right: 12px;
}
.searchtool:hover {
  -webkit-filter: brightness(80%);
  filter: brightness(80%);
}
.searchtool i{
  color: #bfbfbf;
  font-size: 16px;
  position: relative;
  top: 1px;
}
.searchspan {
  width: 120px;
  height: 44px;
  position: relative;
  left: -2px;
  z-index: 2;
}
#search {
  cursor: pointer;
  width: 120px;
  height: 44px;
  line-height: 45px;
  line-height: 44px;
  padding: 0;
  background: 0 0;
  background-color: #4184f3;
  border-radius: 0 10px 10px 0;
  font-size: 17px;
  color: #fff;
  box-shadow: none;
  font-weight: 400;
  border: none;
  outline: 0;
}
#search:hover {
  background-color: #5e9bff;
}
.searchtool svg{
  margin-left: 3px;
}

.showdate{
  display: inline-block;
  font-size: 10px;
}
.tslctline{
  margin-bottom: 10px;
}
.timerange{
  margin: 0;
  line-height: normal;
  padding: 7px 16px;
  clear: both;
  color: #515a6e;
  font-size: 12px!important;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  transition: background .2s ease-in-out;
  margin-top: 5px;
  border-top: 1px solid #e8eaec;
}
// bottom
.divbottom{
  width: 100%;
  min-width: 1250px;
  position: fixed;
  z-index: 302;
  bottom: 0;
  left: 0;
  height: 40px;
  overflow: hidden;
  zoom: 1;
  margin: 0;
  background-color: #fbfbfb;
  text-align: left;
  line-height: 40px;
  color: #bbb;
  font-size: 12px;
}
.bottomleft{
  float: left;
}
.bottomright{
  float: right;
}
.btitem{
  margin-right: 24px;
}
.active{
  color: #4184f3 !important;
  border: 1px dashed #4184f375;
  border-radius: 4px;
}
.active i{
  color: #4e6ef2!important;
  margin-left:2px;
}

.aaaa /deep/ .ivu-select-dropdown {
  max-height: 250px !important;
  overflow: auto !important;

}
/*滚动条样式*/
.aaaa /deep/ .ivu-select-dropdown::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}

.aaaa /deep/ .ivu-select-dropdown::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: rgba(0,0,0,0.2);
}

.aaaa /deep/ .ivu-select-dropdown::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 0;
  background: rgba(0,0,0,0.1);
}
// tab
.tab {
  line-height: 36px;
  height: 38px;
  padding-top: 4px;
  margin: 0 auto;
  width: 760px;
  white-space: nowrap;
  margin-top: 8px;
}
.tabinner {
  margin-left: 5px;
}
.tabinner i{
  font-size: 14px;
  color: #bfbfbf;
}
.tabitem {
  width: auto;
  min-width: 44px;
  margin-right: 8px;
  line-height: 28px;
  text-align: left;
  margin-top: 4px;
  color: #626675;
  padding: 0px 2px;
}
.tabitem:hover{
  //-webkit-filter: brightness(50%);
  //filter: brightness(50%);
  color: #4184f3 !important;
}
.tabitem:hover i{
  color: #4184f3 !important;
}
.tabitem.dis{
  cursor: default;
  color: #c5c8ce;
}
.tabitem svg{
  position: relative;
  top: 3px;
}
//cwapper
.cwrapper {
  width: 1040px;
  margin: 0 auto;
  padding: 14px 24px 0;
}
//关键词搜索
/* 固定表头 */
.simpledata_table{
  width: 100%;
}
.stickythead{
  border-top: none !important;
}
.stickythead th{
  position: sticky;
  top: 0;
  background:#ecf2fe;;
}

.theadDivBox th {
  background: #ecf2fe;
  white-space: nowrap;
  padding: 0 10px;
  height: 30px;
  border-top: none !important;
}
.table-bordered > thead > tr > th, .table-bordered > tbody > tr > th, .table-bordered > tfoot > tr > th, .table-bordered > thead > tr > td, .table-bordered > tbody > tr > td, .table-bordered > tfoot > tr > td {
  border: 1px solid rgba(223, 229, 240, 0.8);
}
.tbodyDiv {
  background: #fff;
  text-align: left;
}

.tbodyDiv tr {
  height: 25px;
}

.tbodyDiv td {
  white-space: nowrap;
  padding: 0 10px;
}
.table-footer {
  margin-top: 24px;
  margin-bottom: 20px;
  float: right;
}
.simpledataDownload{
  cursor: pointer;
  color: rgb(25, 190, 107);
  margin: 0px 2px;
}
.simpledataDownload:hover{
  filter: brightness(90%);
  text-decoration: underline;
}
.downloadSummary_div {
  //width: 965px;
  // min-height: 250px;
  margin: 0 auto;
}

.downloadSummary_top_div {
  height: 40px;
  width: 115px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
}

.downloadSummary_table_div {
  width: 100%;
  border: 1px solid #f0f0f0;
}

.downloadSummary_table tr {
  border-bottom: 1px #c1c1c1 solid;
}

.title_td {
  padding: 16px 24px;
  color: #4773bb;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5715;
  text-align: start;
  white-space: nowrap;
  border-right: 1px solid rgba(223, 229, 240, 0.8);
}

.value_td {
  padding: 16px 13px;
  border-right: 1px solid rgba(223, 229, 240, 0.8);
  display: table-cell;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  line-height: 1.5715;
  word-break: normal;
  overflow-wrap: break-word;
  color: #4773bb;
}

.download_bottomInfo_div {
  margin: 0 auto;
  height: 40px;
  width: 50%;
  margin-top: 30px;
}

.download_bottomInfo_div {
  margin: 0 auto;
  height: 40px;
  width: 50%;
  margin-top: 30px;
}

.addToDownList {
  height: 38px;
  margin-top: 10px;
  margin-bottom: 10px;
  float: right;
}

.download_button {
  width: 135px;
  height: 38px;

}
.aaaa {
  position: relative;
}

.ivu-steps-head {
  height: 28px;
  padding-right: 5px;
}

.aaaa /deep/ .ivu-chart-circle {
  position: absolute !important;
  left: -46px !important;
  top: -23px !important;
  z-index: 999;
}

.ivu-chart-circle {
  position: absolute !important;
  left: -46px !important;
  top: -23px !important;
  z-index: 999;
}

.aaaa /deep/ .ivu-steps-head-inner {
  width: 32px;
  height: 32px;
  line-height: 32px;
  margin-top: 6px;
  margin-left: 6px;
}

.aaaa /deep/ .ivu-icon-ios-checkmark {
  font-size: 32px !important;
  margin-top: -1px !important;
  margin-left: -1px !important;
}

.aaaa /deep/ .ivu-steps-content {
  color: #999;
  margin-left: 12px !important;
}

.aaaa /deep/ .ivu-steps-tail > i {
  margin-top: 8px;
}

.aaaa /deep/ .ivu-steps-title {
  margin-top: 10px !important;
}

.aaaa /deep/ .ivu-spin-fix {
  position: relative !important;
  top: 15px;
  left: 15px;
  background-color: rgba(255, 255, 255, 0);
}

.aaaa /deep/ .ivu-spin-fix .ivu-spin-main {
  position: relative !important;
  left: 0px !important;
}
.loader {
  width: 30px;
  height: 30px;
  position: relative;
  margin: 0 auto;
  top: 12px;
}
.ivu-steps-item{
  padding-top: 10px;
}
.ivu-steps .ivu-steps-tail{
  margin-top: 8px;
}
.ivu-steps .ivu-steps-head{
  margin-left: 0px!important;
  padding-left: 10px!important;
}
.ivu-steps-horizontal .ivu-steps-content{
  padding-left: 47px;
}
.circular {
  -webkit-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;
  height: 100%;
  -webkit-transform-origin: center center;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto
}

.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  -webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round
}

@-webkit-keyframes rotate {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes rotate {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35
  }

  to {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35
  }

  to {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124
  }
}

@-webkit-keyframes color {

  0%,
  to {
    stroke: #d62d20
  }

  40% {
    stroke: #0057e7
  }

  66% {
    stroke: #008744
  }

  80%,
  90% {
    stroke: #ffa700
  }
}

@keyframes color {

  0%,
  to {
    stroke: #d62d20
  }

  40% {
    stroke: #0057e7
  }

  66% {
    stroke: #008744
  }

  80%,
  90% {
    stroke: #ffa700
  }
}
</style>
